import { format } from "date-fns";
import { de } from "date-fns/locale";

export namespace Utils {
  export function hasText(v: any): v is string {
    return typeof v === "string" && !!v.trim();
  }
  
  export const formatToLocalDate = (date: Date | number | string) => {
    if (!date) return "";
    const dateObj = typeof date === "string" ? new Date(date) : date;
    format(dateObj, "dd.MM.yyyy HH:mm", { locale: de });
  }
}
